import { round } from 'lodash'
import { getDateWithNumVersion } from 'common/utils/DateUtil'

// « Bugs critiques post-release » = tickets catégorie Anomalie, priorité P1+P2 (Urgente/Immédiate),
// créés dans les 15 jours suivant la mise en production d'une version. La date de release est
// dérivée du numéro de version (X.YY.jour.HHMM) via getDateWithNumVersion.
export const CRITICAL_PRIORITIES = ['Urgente', 'Immédiate']

const WINDOW_DAYS = 15
const DAY_SEC = 86400

// Par version : fenêtre [release, min(release + 15j, release de la version suivante)]. Le plafonnement
// à la version suivante évite de compter deux fois un ticket quand deux releases sont espacées de < 15j.
// Retour trié de la version la plus récente à la plus ancienne.
export const computePostReleaseBugs = (versions, anomalies) => {
    const withDates = versions
        .map(version => ({ version, releaseMs: getDateWithNumVersion(version) }))
        .filter(v => Number.isFinite(v.releaseMs))
        .sort((a, b) => b.releaseMs - a.releaseMs)

    const criticals = anomalies.filter(a =>
        CRITICAL_PRIORITIES.includes(a.priority) && Number.isFinite(a.dateSubmitted),
    )

    return withDates.map((v, index) => {
        const startSec = Math.floor(v.releaseMs / 1000)
        const nextReleaseSec = index > 0 ? Math.floor(withDates[index - 1].releaseMs / 1000) : undefined
        const capSec = startSec + (WINDOW_DAYS * DAY_SEC)
        const endSec = Number.isFinite(nextReleaseSec) ? Math.min(capSec, nextReleaseSec) : capSec
        const tickets = criticals.filter(a => a.dateSubmitted >= startSec && a.dateSubmitted < endSec)
        return { version: v.version, releaseMs: v.releaseMs, count: tickets.length, tickets }
    })
}

const mean = (values) => (values.length ? round(values.reduce((acc, n) => acc + n, 0) / values.length, 1) : undefined)

// Moyennes du nombre de bugs post-release par version : sur toutes les versions, sur les 5 dernières,
// et sur les versions déployées durant les 365 derniers jours. `stats` est trié du plus récent au plus ancien.
export const computeAverages = (stats) => {
    const nowSec = Date.now() / 1000
    const yearAgoSec = nowSec - (365 * DAY_SEC)
    const yearCounts = stats.filter(s => (s.releaseMs / 1000) >= yearAgoSec).map(s => s.count)
    return {
        moyenneComplete: mean(stats.map(s => s.count)),
        moyenne5: mean(stats.slice(0, 5).map(s => s.count)),
        moyenneAnnee: mean(yearCounts),
        nbVersions: stats.length,
    }
}
